import type { Hit as AlgoliaHit } from 'instantsearch.js/es/types';

import { Snippet } from 'react-instantsearch-hooks-web';

export type OrdersHitProps = {
  hit: AlgoliaHit<{
    ReportingCustName: string;
    JobOrder: string;
    ReportingCustID: string;
    MaterialDesc: string;
    SKU: string;
  }>;
};

export function OrdersHit({ hit }: OrdersHitProps) {
  return (
    <article className="hit">
      <div>
        <div>
          By <strong><Snippet hit={hit} attribute="ReportingCustName" /></strong>
        </div>
        <div>
          Customer ID: <strong>{hit.ReportingCustID}</strong>
        </div>
        <div>
          Job Order: <strong>{hit.JobOrder}</strong>
        </div>
        <div>
          Material Desc: <strong>{hit.MaterialDesc}</strong>
        </div>
        <div>
          SKU: <strong>{hit.SKU}</strong>
        </div>
        
      </div>
    </article>
  );
}